module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/hu-7ae2a1f04ec537fbba4bea8c15126490.svg";